import { formatDate } from '@angular/common';
// import { FORMAT_DATE_TIME_COMPACT, FORMAT_DATE_TIME_LOCAL, FORMAT_TIME_MS } from '../../common';

export const arrayCommaFormatter = (params) => ((Array.isArray(params.value) && params.value.length) ? params.value.join(', ') : '');

export const dateFormatter = (value, format, placeholder = '') => (value ? formatDate(value, format, 'en-GB') : placeholder);
